<div>{{'login_redirect_message'| i18n}}</div>
